<script setup>
import { computed } from "vue";
//- LRR import { RouterLink } from "vue-router";
import { Link } from '@inertiajs/inertia-vue3';
import { getButtonColor } from "@/colors.js";
import BaseIcon from "@/Components/BaseIcon.vue";

const props = defineProps({
  label: {
    type: [String, Number],
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  iconSize: {
    type: [String, Number],
    default: null,
  },
  href: {
    type: String,
    default: null,
  },
  target: {
    type: String,
    default: null,
  },
  to: {
    type: [String, Object],
    default: null,
  },
  type: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: "white",
  },
  as: {
    type: String,
    default: null,
  },
  inertiahref: {
    type: String,
    default: null,
  },
  small: Boolean,
  outline: Boolean,
  active: Boolean,
  disabled: Boolean,
  roundedFull: Boolean,
  whitespaceNormal: Boolean,
  wFull: Boolean
});

const is = computed(() => {
  if (props.as) {
    return props.as;
  }

  if (props.to) {
    //LRR return RouterLink;
    return Link;
  }

  if (props.href) {
    return "a";
  }

  return "button";
});

const computedType = computed(() => {
  if (is.value === "button") {
    return props.type ?? "button";
  }

  return null;
});

const labelClass = computed(() =>
  props.small && props.icon ? "px-1" : "px-2"
);

const componentClass = computed(() => {
  const base = [
    // AAC: Botones con 100% de ancho de pantalla en Smartphone
    // "inline-flex",
    (props.wFull ? "w-full lg:inline-flex lg:w-auto" : "inline-flex"),
    "cursor-pointer",
    "justify-center",
    "items-center",
    (props.whitespaceNormal ? "whitespace-normal" : "whitespace-nowrap"),
    "focus:outline-none",
    "transition-colors",
    "focus:ring",
    "duration-150",
    "border",
    props.roundedFull ? "rounded-full" : "rounded",
    getButtonColor(props.color, props.outline, !props.disabled, props.active),
  ];

  if (!props.label && props.icon) {
    base.push("p-1");
  } else if (props.small) {
    base.push("text-sm", props.roundedFull ? "px-3 py-1" : "p-1");
  } else {
    base.push("py-2", props.roundedFull ? "px-6" : "px-3");
  }

  if (props.disabled) {
    base.push(
      "cursor-not-allowed",
      props.outline ? "opacity-50" : "opacity-70"
    );
  }



  return base;
});
</script>
<!-- LRR Agregar Link inertia -->
<template>
  <Link v-if="inertiahref" :href="inertiahref">
  <component :is="is" :class="componentClass" :href="href" :type="computedType" :to="to" :target="target" :disabled="disabled">
    <BaseIcon v-if="icon" :path="icon" :size="iconSize" />
    <span v-if="label" :class="labelClass">{{ label }}</span>
  </component>
  </Link>
  <component v-else :is="is" :class="componentClass" :href="href" :type="computedType" :to="to" :target="target" :disabled="disabled">
    <BaseIcon v-if="icon" :path="icon" :size="iconSize" />
    <span v-if="label" :class="labelClass">{{ label }}</span>
  </component>
</template>

